var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHot = function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Hot deal"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2839"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2740"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6080",
    d: "m11.113 46.737-.055.768c-.055.764-.11 1.525-.11 2.344a29.337 29.337 0 0 0 29.048 29.549A29.34 29.34 0 0 0 69.051 49.85c0-.559 0-1.119-.035-1.675-.473-16.769-8.6-20.973-8.944-21.143a1.572 1.572 0 0 0-1.462.028 1.654 1.654 0 0 0-.843 1.217c-.012.11-1.505 10.126-8.085 11.552a73.9 73.9 0 0 0-1.663-16.651A41.783 41.783 0 0 0 32.858.906 1.58 1.58 0 0 0 31.184.78a1.659 1.659 0 0 0-.879 1.462c0 7.667-3.794 12.86-8.187 18.881-4.74 6.5-10.118 13.861-11 25.615m38.564 18.884a10.13 10.13 0 0 1-9.686 10.493 10.128 10.128 0 0 1-9.685-10.492c0-.3.02-.587.043-.871a18.852 18.852 0 0 1 4.142-10.249 21.305 21.305 0 0 0 3.317-6.21 16 16 0 0 1 3.27 6.292 33.463 33.463 0 0 1 .613 7.471 1.628 1.628 0 0 0 1.615 1.642 5.912 5.912 0 0 0 5.331-3.924 13.507 13.507 0 0 1 1.02 5.213c.012.221.012.406.008.583Z",
    fill: "#ffcf31",
    fillRule: "evenodd"
  }))))));
};
export default SvgHot;